/* import __COLOCATED_TEMPLATE__ from './project-selector.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class PlaylistFormProjectSelectorComponent extends Component {
  @tracked selectedProject = null;

  @action
  setSelectedProject(project) {
    this.selectedProject = project;
  }

  @action
  addEntry() {
    this.args.addEntry(this.selectedProject);
    this.selectedProject = null;
  }
}
